import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FuyouhinKaisyu from "../pages/fuyouhin-kaisyu/page";
import IhinSeiri from "../pages/ihin-seiri/page";
import GomiYashiki from "../pages/gomi-yashiki/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/fuyouhin-kaisyu",
    element: <FuyouhinKaisyu />,
  },
  {
    path: "/ihin-seiri",
    element: <IhinSeiri />,
  },
  {
    path: "/gomi-yashiki",
    element: <GomiYashiki />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
